module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am748-67ee87750999f7bf252bc030fa2bf7ee.jpg";